import React from 'react';
import { Button, Table, Form, Segment, Select, Grid, Popup, Header, Label, Icon } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import EditCourse from '../CreateStudyProgramImplementation/EditCourse';
import { Link } from 'react-router-dom';
import SearchTableData from '../../util/SearchTableData';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


const NoDataMessage = () => <p>Nema predmeta.</p>;

export default class SPImplCourses extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            studyProgramSemesterId: '',
            studyProgramSemesterId_: '',
            semesters: [],
            course: null,

            showEditMode: false,
            showChangeSemesterMode: false,
            semErr: false,
            semErr_: false,

            results: [],
            confirmation: false
        };

        this.getDataToRender = this.getDataToRender.bind(this);
        this.getCourses = this.getCourses.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.addSemester = this.addSemester.bind(this);
        this.removeSemester = this.removeSemester.bind(this);
        this.getResults = this.getResults.bind(this);
    }

    componentDidMount() {
        this.getCourses();
        const implementation = this.props.location.state && this.props.location.state.implementation ? this.props.location.state.implementation : JSON.parse(localStorage.getItem('implementation'));
        axios.get(`study-programs/semesters/${implementation.studyProgram.id}`)
            .then(res => {
                this.setState({
                    semesters: res.data.map(el => ({
                        ...el, key: el.id, value: el.id.toString(), text: el.studyProgramSemester.name
                    }))
                });
            })
            .catch(err => {
                console.log('Failed to fetch semesters');
            });
    }

    getCourses(refresh) {
        const implementation = this.props.location.state && this.props.location.state.implementation ? this.props.location.state.implementation : JSON.parse(localStorage.getItem('implementation'));
        let obj = {
            studyProgramId: implementation.studyProgram.id
        };
        axios.post('study-programs/courses', { ...obj })
            .then(res => {
                this.setState({
                    data: res.data.map(el => ({
                        ...el, courseBasicName: el.courseStudyProgram.courseBasic.name
                    }))
                });
                if (refresh) {
                    this.setState({
                        semesters_: res.data.map(el => ({
                            ...el, courseBasicName: el.courseStudyProgram.courseBasic.name
                        })).find(el => el.courseStudyProgram.id === this.state.course.id).studyProgramSemesters
                    });
                }
            })
            .catch(err => {
                console.log('Failed to fetch courses');
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    addSemester() {
        const { course } = this.state;
        if (!this.state.studyProgramSemesterId) {
            this.setState({ semErr: true });
            toast('Morate unijeti broj semestra.');
            return;
        }
        this.setState({ semErr: false });

        let obj = { id: course.id };
        axios.post(`study-programs/course/add-semester/${parseInt(this.state.studyProgramSemesterId, 10)}`, { ...obj })
            .then(re => {
                toast('Predmet je uspješno dodan na semestar.');
                let refresh = true;
                this.getCourses(refresh);
            })
            .catch(err => {
                if (err.message === 'Network Error') {
                    toast('Predmet je uspješno dodan na semestar.');
                    let refresh = true;
                    this.getCourses(refresh);
                } else {
                    toast('Došlo je do greške! Dodavanje predmeta na semestar nije uspjelo.');
                }
            });
    }

    removeSemester(studyProgramSemesterId) {
        const { course } = this.state;

        let obj = { id: course.id };

        axios.put(`study-programs/course/remove-semester/${studyProgramSemesterId}`, { ...obj })
            .then(res => {
                toast('Predmet je uklonjen sa semestra.');
                let refresh = true;
                this.getCourses(refresh);
            })
            .catch(err => {
                toast('Došlo je do greške! Predmet nije uklonjen sa semestra.');
            });
    }

    removeUnusedCourse(studyProgramId, courseStudyProgramId) {
        axios.delete(`study-programs/course/remove-unused-course/${studyProgramId}/${courseStudyProgramId}`)
            .then(res => {
                toast(res.data || 'Predmet je uklonjen sa programa.');
                this.getCourses(true);
            })
            .catch(err => {
                let msg = 'Došlo je do greške! Predmet nije uklonjen sa programa.';
                try { if (err.response && err.response.data) msg = err.response.data; } catch(e){}
                toast(msg);
            });

    }


    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.data;
    }

    getResults(results) {
        this.setState({ results });
    }


    render() {
        const implementation1 = this.props.location.state && this.props.location.state.implementation ? this.props.location.state.implementation : JSON.parse(localStorage.getItem('implementation'));
        return (
            <div>
                <h1>Pregled predmeta</h1>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            <Header.Content>
                                {localStorage.getItem('basicName')} -  {implementation1.studyProgram.name}

                            </Header.Content>
                            <Header.Subheader>{implementation1.studyProgram.description}</Header.Subheader>
                        </Header>
                    </Segment>
                    <Segment>

                        {this.state.showEditMode &&
                        <EditCourse
                            closeEditMode={() => this.setState({ showEditMode: false })}
                            course={this.state.course}
                            getCoursesForSemester={() => this.getCourses()}
                        />}
                        {this.state.showChangeSemesterMode && <div>
                            <Button
                                circular
                                icon="close"
                                size="small"
                                iverted
                                basic="true"
                                floated="right"
                                onClick={() => this.setState({ showChangeSemesterMode: false })}
                            />
                            <Header as="h3">{this.state.course.courseBasic.name}
                                <Header.Subheader floated="left">
                                    Predmet
                                </Header.Subheader>
                            </Header>


                            <Grid divided="vertically">
                                <Grid.Row columns={2}>
                                    <Grid.Column><div style={{ marginLeft: '3%' }}>
                                        {this.state.semesters_.length ? <Table celled selectable compact>
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell>Broj semestra</Table.HeaderCell>
                                                    <Table.HeaderCell />
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body> {this.state.semesters_.map((el, index) =>
                                                (<Table.Row key={index}>
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.studyProgramSemester.name}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle" textAlign="center">
                                                        <Button color="red" basic="true" onClick={() => this.removeSemester(el.id)}>Ukloni semestar</Button>
                                                    </Table.Cell>
                                                </Table.Row>))}
                                            </Table.Body>
                                        </Table> : 'Predmet se ne nalazi ni na jednom semestru.'}</div>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Form>
                                            <Form.Group widths="equal">
                                                <Form.Field
                                                    error={this.state.semErr}
                                                    control={Select}
                                                    clearable
                                                    options={this.state.semesters}
                                                    label="Dodavanje semestra predmetu"
                                                    value={this.state.studyProgramSemesterId}
                                                    onChange={this.handleInputChange}
                                                    name="studyProgramSemesterId"
                                                    placeholder="Odaberite broj semestra"
                                                />
                                                <Form.Button
                                                    color="blue"
                                                    label=" "
                                                    onClick={this.addSemester}
                                                >  Dodaj semestar
                                                </Form.Button>
                                            </Form.Group>


                                        </Form>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>

                            <br />
                        </div>
                        }


                        {this.getDataToRender().length ?
                            <Table celled selectable compact>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan={9} >
                                            <div style={{ paddingLeft: '30px' }}>
                                                <SearchTableData data={this.state.data} getResults={this.getResults} filterItem={['courseBasicName']} />
                                            </div>
                                        </Table.HeaderCell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan="2">Naziv predmeta</Table.HeaderCell>
                                        <Table.HeaderCell width="1">ECTS</Table.HeaderCell>
                                        <Table.HeaderCell>Šifra</Table.HeaderCell>
                                        <Table.HeaderCell>Predavanja + vježbe + seminari + tutorijali</Table.HeaderCell>
                                        <Table.HeaderCell>Semestar</Table.HeaderCell>
                                        <Table.HeaderCell>Tip predmeta</Table.HeaderCell>
                                        <Table.HeaderCell>Komentar</Table.HeaderCell>
                                        <Table.HeaderCell />
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body> {this.getDataToRender().map((el, index) =>
                                    (<Table.Row key={index}>
                                        <Table.Cell verticalAlign="middle" colSpan="2">
                                            {el.courseBasicName}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.courseStudyProgram.ects}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.courseStudyProgram.code}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.courseStudyProgram.lectureNumber ? el.courseStudyProgram.lectureNumber : '0'} + {el.courseStudyProgram.exerciseNumber ? el.courseStudyProgram.exerciseNumber : '0'} + {el.courseStudyProgram.seminarNumber ? el.courseStudyProgram.seminarNumber : '0'} + {el.courseStudyProgram.tutorialNumber ? el.courseStudyProgram.tutorialNumber : '0'}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.studyProgramSemesters.map((e, index) => (<div>{(el.studyProgramSemesters.length > 1 && index !== el.studyProgramSemesters.length - 1) ? e.studyProgramSemester.name + ', ' : e.studyProgramSemester.name}</div>))}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.courseStudyProgram.mandatory ? 'Obavezan' : 'Izborni'}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            <Grid centered className="stackable">
                                                <Grid.Row verticalAlign="middle">
                                                    <Grid.Column verticalAlign="middle" textAlign="right">
                                                        <span style={{ color: '#a6a4a1' }}>
                                                            {el.courseStudyProgram.courseBasic.comment && <Label as="a" basic><Icon name="comment alternate outline" />{el.courseStudyProgram.courseBasic.comment}</Label>}
                                                            {el.courseStudyProgram.fromOtherStudyProgram && <Label as="a" basic><Icon name="share" />sa drugog SP/NPP</Label>}
                                                            {el.courseStudyProgram.prerequisiteCourse && <Label as="a" basic><Icon name="warning" />uslovni predmet</Label>}
                                                        </span>
                                                    </Grid.Column>
                                                </Grid.Row>
                                            </Grid>
                                            {/* {el.courseBasic.name} */}
                                        </Table.Cell>
                                        {/* <Table.Cell verticalAlign="middle"> */}
                                        {/*    {el.courseStudyProgram.courseBasic.comment} */}
                                        {/* </Table.Cell> */}
                                        <Table.Cell textAlign="center" verticalAlign="middle">
                                            {this.state.confirmation === index ? (
                                                <div>
                                                    <h4>Jeste li sigurni?</h4>
                                                    <Button.Group>
                                                        <Button
                                                            basic
                                                            color="blue"
                                                            onClick={() => {
                                                                const implementation =
                                                                    (this.props.location.state && this.props.location.state.implementation)
                                                                        ? this.props.location.state.implementation
                                                                        : JSON.parse(localStorage.getItem('implementation'));

                                                                const studyProgramId = implementation.studyProgram.id;
                                                                const courseStudyProgramId = el.courseStudyProgram.id;

                                                                this.removeUnusedCourse(studyProgramId, courseStudyProgramId);
                                                                this.setState({ confirmation: false });
                                                            }}
                                                        >
                                                            DA
                                                        </Button>
                                                        <Button
                                                            basic
                                                            color="red"
                                                            onClick={() => { this.setState({ confirmation: false }); }}
                                                        >
                                                            NE
                                                        </Button>
                                                    </Button.Group>
                                                </div>
                                            ) : (
                                                <React.Fragment>
                                                    <Popup
                                                        content="Izmijeni predmet"
                                                        position="top center"
                                                        trigger={
                                                            <Button
                                                                basic="true"
                                                                circular
                                                                icon="pencil alternative"
                                                                size="small"
                                                                color="green"
                                                                onClick={() => {
                                                                    window.scrollTo(0, 0); this.setState({
                                                                        showEditMode: true,
                                                                        course: el.courseStudyProgram,
                                                                        showChangeSemesterMode: !el.studyProgramSemesters.length,
                                                                        semesters_: el.studyProgramSemesters
                                                                    });
                                                                }}
                                                            >
                                                            </Button>
                                                        }
                                                    />
                                                    <Popup
                                                        content="Semestri"
                                                        position="top center"
                                                        trigger={
                                                            <Button
                                                                basic="true"
                                                                color="blue"
                                                                size="small"
                                                                circular
                                                                icon="copy outline"
                                                                onClick={() => {
                                                                    window.scrollTo(0, 0); this.setState({
                                                                        showChangeSemesterMode: true,
                                                                        course: el.courseStudyProgram,
                                                                        semesters_: el.studyProgramSemesters,
                                                                        showEditMode: !!((!el.courseStudyProgram.ects || !el.courseStudyProgram.exerciseNumber || !el.courseStudyProgram.lectureNumber)),
                                                                    });
                                                                }}
                                                            >
                                                            </Button>
                                                        }
                                                    />
                                                    <Popup
                                                        content={
                                                            (el.studyProgramSemesters && el.studyProgramSemesters.length > 0)
                                                                ? 'Ne može se obrisati: predmet je dodijeljen nekom semestru.'
                                                                : 'Obriši predmet'
                                                        }
                                                        position="top center"
                                                        trigger={
                                                            <span>
                                                                <Button
                                                                    basic
                                                                    circular
                                                                    icon="trash alternate"
                                                                    size="small"
                                                                    color="red"
                                                                    disabled={!!(el.studyProgramSemesters && el.studyProgramSemesters.length > 0)}
                                                                    onClick={() => {
                                                                        if (el.studyProgramSemesters && el.studyProgramSemesters.length > 0) return;
                                                                        this.setState({ confirmation: index });
                                                                    }}
                                                                />
                                                              </span>
                                                        }
                                                    />
                                                </React.Fragment>
                                            )}
                                        </Table.Cell>

                                    </Table.Row>))}
                                </Table.Body>
                            </Table>
                            : <NoDataMessage />
                        }
                    </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgram/SPImplCourses.js